import React from 'react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46114651766972:1';
export function PricingSection() {
  return <section className="relative bg-white py-10 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-91">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-garden-bg rounded-full opacity-50 blur-3xl pointer-events-none" data-id="element-92"></div>

      <div className="max-w-xl mx-auto relative z-10" data-id="element-93">
        <div className="bg-white rounded-3xl shadow-2xl border border-neutral-beige overflow-hidden transform transition-all hover:shadow-[0_20px_50px_rgba(47,93,58,0.15)]" data-id="element-94">
          <div className="bg-gradient-garden py-3 text-center relative overflow-hidden" data-id="element-95">
            <div className="absolute inset-0 bg-white/10 opacity-30" data-id="element-96"></div>
            <h2 className="font-serif text-lg sm:text-xl font-black text-white uppercase tracking-widest relative z-10 drop-shadow-md" data-id="element-97">
              ⏰ Oferta por tiempo limitado
            </h2>
          </div>

          <div className="p-5 sm:p-8" data-id="element-98">
            <h3 className="text-lg sm:text-xl font-black text-[#1A1A1A] mb-4 text-center" data-id="element-99">
              📦 Lo que recibís hoy:
            </h3>

            <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm font-semibold text-gray-700 mb-6 bg-neutral-bg p-4 rounded-2xl border border-neutral-beige" data-id="element-100">
              <span className="flex items-center" data-id="element-101">
                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-2 text-xs" data-id="element-102">
                  ✓
                </span>
                Manual completo (6 tomos)
              </span>
              <span className="flex items-center" data-id="element-103">
                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-2 text-xs" data-id="element-104">
                  ✓
                </span>
                Bonos incluidos
              </span>
              <span className="flex items-center" data-id="element-105">
                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-2 text-xs" data-id="element-106">
                  ✓
                </span>
                Pack de plantillas
              </span>
              <span className="flex items-center" data-id="element-107">
                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-2 text-xs" data-id="element-108">
                  ✓
                </span>
                Acceso inmediato
              </span>
              <span className="flex items-center" data-id="element-109">
                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-2 text-xs" data-id="element-110">
                  ✓
                </span>
                Descarga digital
              </span>
              <span className="flex items-center" data-id="element-111">
                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-earth-light/30 text-earth-accent flex items-center justify-center mr-2 text-xs" data-id="element-112">
                  ★
                </span>
                Acceso de por vida
              </span>
            </div>

            <div className="text-center mb-6" data-id="element-113">
              <p className="text-base text-gray-400 font-bold line-through mb-1" data-id="element-114">
                💰 Precio regular: ARS $59.999
              </p>
              <p className="text-3xl sm:text-4xl font-black text-gradient-garden drop-shadow-sm" data-id="element-115">
                🔥 HOY: ARS $19.990
              </p>
            </div>

            <div className="relative group" data-id="element-116">
              <div className="absolute -inset-1 bg-gradient-to-r from-garden-medium to-garden-dark rounded-full blur opacity-40 group-hover:opacity-75 transition duration-500 animate-pulse-glow" data-id="element-117"></div>
              <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="relative block w-full text-center bg-gradient-garden hover:from-[#1e3d25] hover:to-garden-dark text-white font-black text-lg py-4 rounded-full shadow-xl transform transition-all duration-300 hover:-translate-y-1" data-id="element-118">
                👉 OBTENER MI MANUAL AHORA
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}